var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-select',_vm._g(_vm._b({attrs:{"value":_vm.value,"label":"Type","option-value":"value","option-label":"label","emit-value":"","map-options":"","options":_vm.$options.CUSTOMERS_TYPE_LIST}},'q-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }